import rootReducer from '../reducers';
import thunk from 'redux-thunk';
import routes from '../routes';
import {reduxReactRouter} from 'redux-router';
import createHistory from 'history/lib/createHashHistory';
import {applyMiddleware, compose, createStore} from 'redux';
import createLogger from 'redux-logger';

export default function configureStore(initialState) {
    let createStoreWithMiddleware;
    let history = createHistory({
        queryKey: false
    });

    const logger = createLogger();

    const middleware = applyMiddleware(thunk,logger);
    // const middleware = applyMiddleware(thunk);

    createStoreWithMiddleware = compose(
     middleware,
     reduxReactRouter({routes, history})
    );

    const store = createStoreWithMiddleware(createStore)(rootReducer, initialState);

    if (import.meta.hot) {
        import.meta.hot.accept('../reducers/index.js', (newModule) => {
            if (newModule && newModule.default) store.replaceReducer(newModule.default);
        });
    }

    return store;

}
